import { APIRequest } from "@/utils/api";

export const CubeOrderAPI = new APIRequest({
  baseURL: "/api/wms/v2/cube/orders",
});
